import generateId from 'uuid/v1'

async function markSampleForDeletion (sampleId) {
  if (!this.dbClient) return
  await this.dbClient.transaction('rw', ['samples'], async () => {
    return this.dbClient.samples.update(sampleId, { delete: true, alias: generateId() })
  })
}

export default markSampleForDeletion